import { useEventListener } from "./useEventListener";
import { useCallback, useEffect, useState } from "react";
import { debounce } from "../helpers";

export const useWindow = () => {
  const [refresh, setRefresh] = useState(window.innerHeight);
  const [windowState, setWindowState] = useState(window);

  const onWindowChange = useCallback(
    debounce(() => {
      setRefresh(window.innerHeight);
    }, 200),
    [setWindowState]
  );

  useEffect(() => {
    setWindowState(window);
  }, [refresh]);

  useEventListener("resize", onWindowChange);
  useEventListener("orientationchange", onWindowChange);

  return windowState;
};
